export class OfflineDataDateUpdate {
    id: number;
    syncronizationDate: Date;

    constructor() {
        this.id = 0;
        this.syncronizationDate = new Date();
    }
}